export default __webpack_public_path__ + "static/media/AndyBernard.841b1b67.jpg";